/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ILayoutConfig, LAYOUT_TYPE } from "../../../ui/components/Layout/LayoutTypes";

export const ReferenceGuideLayoutConfig: ILayoutConfig = {
	root: {
		type: LAYOUT_TYPE.ROW,
		id: "layout",
		children: [
			{
				type: LAYOUT_TYPE.PANEL,
				id: "sidebar",
				isExpandable: false,
				contentComponent: "sidebar",
				size: "233px"
			},
			{
				type: LAYOUT_TYPE.SPLITTER,
				id: "referenceLeftSpliter"
			},
			{
				type: LAYOUT_TYPE.PANEL,
				id: "main",
				isExpandable: false,
				contentComponent: "main"
				// size: 15
			},
			{
				type: LAYOUT_TYPE.SPLITTER,
				id: "referenceRightSpliter"
			},
			{
				type: LAYOUT_TYPE.PANEL,
				id: "rightbar",
				isExpandable: false,
				contentComponent: "rightbar",
				size: "233px"
			}
		]
	}
};
